/* Native details remain usable without JavaScript. */
(() => {
  if (window.__shipitoLandingHeaderReady) return;
  window.__shipitoLandingHeaderReady = true;
  const selector = '[data-lp-header] .lp-header-disclosure';
  document.addEventListener('toggle', event => {
    const current = event.target;
    if (!(current instanceof Element) || !current.matches(selector) || !current.open) return;
    current.closest('[data-lp-header]').querySelectorAll('.lp-header-disclosure[open]').forEach(other => {
      if (other !== current) other.open = false;
    });
    if (current.classList.contains('lp-header-search')) current.querySelector('input[type="search"]')?.focus();
  }, true);
  document.addEventListener('click', event => {
    document.querySelectorAll(`${selector}[open]`).forEach(disclosure => {
      if (!disclosure.contains(event.target)) disclosure.open = false;
      else if (event.target.closest('.lp-header-menu-panel a')) disclosure.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(`${selector}[open]`).forEach(disclosure => {
      const heldFocus = disclosure.contains(document.activeElement);
      disclosure.open = false;
      if (heldFocus) disclosure.querySelector('summary')?.focus();
    });
  });
})();
